import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import useMobile from '../hooks/use-mobile';
import Text from '../text';
import Colors from '../colors';
import Spacer from '../spacer';
import ProgressBar from '../progress-bar';
const StyledContainer = styled.View`
  align-items: left;
  width: 100%;
  padding: ${props => props.mobile ? 16 : 32}px;
  padding-bottom: ${props => props.mobile ? 24 : 32}px;
`;
const StyledTextGroup = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;

const getProgressText = (step, totalSteps) => `Step ${step} of ${totalSteps}`;

const styles = {
  text: {
    lineHeight: '150%'
  }
};
export default function Header(props) {
  const mobile = useMobile();
  const spacer = mobile ? 'f16' : 'f24';
  const progress = props.step / props.totalSteps * 100;
  return /*#__PURE__*/React.createElement(StyledContainer, {
    mobile: mobile
  }, /*#__PURE__*/React.createElement(ProgressBar, {
    progress: progress
  }), /*#__PURE__*/React.createElement(Spacer, {
    size: spacer,
    height: true
  }), /*#__PURE__*/React.createElement(StyledTextGroup, null, /*#__PURE__*/React.createElement(Text.H5, {
    weight: "medium",
    color: Colors.gray600
  }, props.title), /*#__PURE__*/React.createElement(Text.BodyExtraSmall, {
    weight: "regular",
    color: Colors.advanceBlue400,
    style: styles.text
  }, getProgressText(props.step, props.totalSteps))), /*#__PURE__*/React.createElement(Spacer, {
    size: "f8",
    height: true
  }), /*#__PURE__*/React.createElement(Text.BodyBase, {
    weight: "regular",
    color: Colors.gray400
  }, props.description));
}
Header.defaultProps = {
  title: 'Title',
  description: 'Description',
  step: 1,
  totalSteps: 8
};
Header.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  step: PropTypes.number,
  totalSteps: PropTypes.number
};
//# sourceMappingURL=header.js.map